import React, { useContext, useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContextProvider";

function SignupWithGoogle() {
  const navigate = useNavigate();
  const { setAuthAndPersist, setLoginUserAndPersist } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const decoded = jwtDecode(credentialResponse.credential);

      const userData = {
        googleId: decoded.sub,
        firstName: decoded.given_name,
        lastName: decoded.family_name,
        email_id: decoded.email,
        profile_image: decoded.picture,
        username: `${decoded.given_name} ${decoded.family_name}`,
      };

      // Send user data to the backend
      const response = await fetch(
        "https://domains-marketplace-backend.vercel.app/sam/doc/users/google-signup",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(userData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        toast.success("Congratulations! You have successfully signed up.");
        setAuthAndPersist(true); // Updates both state and localStorage
        setLoginUserAndPersist(result.user); // Updates both state and localStorage
        navigate("/Marketplace");
      } else if (response.status === 409) {
        // Handle existing user case
        toast.error(result.message);
      } else {
        toast.error(`${result.message}`);
      }

      setIsLoading(false);
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      setIsLoading(false);
    }
  };

  //

  return (
    <div>
      <GoogleOAuthProvider clientId="363641818437-hhrq97hkl5dikvnmsb5e2u3u67of6rru.apps.googleusercontent.com">
        {!isLoading ? (
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={() => {
              toast.error("Login Failed");
            }}
            width="100%"
            size="large" 
            text="signup_with"
            logo_alignment="center"
          />
        ) : (
          <p className="items-center flex gap-[8px] w-full justify-center">
            <span className="loading loading-spinner loading-sm"></span> Signing
            Up...
          </p>
        )}
      </GoogleOAuthProvider>
      <br />
    </div>
  );
}

export default SignupWithGoogle;
